import Cookies from 'js-cookie'
const AppCookiesCode = 'partner-eis-Code'
const TokenKey = 'partner-eis-Token'
const AppCookiesKey = 'partner-eis-AppKey'
export function getToken () {
  return Cookies.get(TokenKey)
}
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken () {
  return Cookies.remove(TokenKey)
}
// export function setAppkey(token) {
//   return Cookies.set(setAppkey, token)
// }
export function getAppKey () {
  return Cookies.get(AppCookiesKey)
}
export function removeAppkey () {
  return Cookies.remove(AppCookiesKey)
}
export function setAppkey (appKey) {
  return Cookies.set(AppCookiesKey, appKey)
}
export function getCustomerToken () {
  return Cookies.get(AppCookiesCode)
}
export function setCustomerToken (code) {
  return Cookies.set(AppCookiesCode, code)
}
export function removeCustomerToken () {
  return Cookies.remove(AppCookiesCode)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js